import { createContext, useContext, ReactNode, Component } from 'react';
import Analytics from './analyticsInterface';
import { NoOpTracker } from './noOpTracker';
import { GoogleAnalyticsTracker } from './googleAnalyticsTracker';
import { AemTracker } from './aemTracker';

const AnalyticsContext = createContext<Analytics | undefined>(undefined);

export const useAnalyticsTracking = (): Analytics => {
    const analytics = useContext(AnalyticsContext);
    if (!analytics) {
        throw new Error('useAnalytics must be used within an AnalyticsProvider');
    }
    return analytics;
};

interface AnalyticsProviderProps {
    children: ReactNode;
    value: string;
}

export class AnalyticsProvider extends Component<AnalyticsProviderProps> {
    private analytics: Analytics;
    constructor(props: AnalyticsProviderProps) {
        super(props);
        switch (props.value) {
            case 'googleAnalytics':
                this.analytics = new GoogleAnalyticsTracker();
                break;
            case 'aemAnalytics':
                this.analytics = new AemTracker();
                break;
            default:
                this.analytics = new NoOpTracker();
                break;
        }
    }

    render() {
        return (
            <AnalyticsContext.Provider value={this.analytics}>
                {this.props.children}
            </AnalyticsContext.Provider>
        );
    }
}
